import { NgModule } from "@angular/core";
import { AppCommonModule } from "../../common/app-common.module";
import { OneiamErrorComponent } from "./oneiam-error.component";

@NgModule({
  imports: [
    AppCommonModule
  ],
  declarations: [
    OneiamErrorComponent
  ],
  exports: [
    OneiamErrorComponent
  ]
})
export class OneiamErrorModule {}



// WEBPACK FOOTER //
// ./src/app/errors/oneiam-error/oneiam-error.module.ts